import { ResponseCatalog } from 'Models'
import { AppState } from 'Src/store'
import { createSelector } from 'reselect'
import { ProductsCore } from 'Pages/orders_design'

const getItems = (state: AppState) => state.orders_design.orderProducts.items
const getProductsCore = createSelector(getItems, (products) => new ProductsCore(products.entries))
const getParams = (state: AppState) => state.orders_design.orderProducts.params
const getRecommendations = (state: AppState) => state.orders_design.orderProducts.recommendations
const getBusinessapps = (state: AppState) => state.orders_design.orderProducts.businessapps

const getFilteredProducts = createSelector(
	getItems,
	(products) =>
		new ResponseCatalog({
			entries: products.entries.filter((product) => !product.only_rbidos_type),
		})
)

export const productSelectors = {
	getItems,
	getProductsCore,
	getParams,
	getRecommendations,
	getFilteredProducts,
	getBusinessapps,
}
